document.addEventListener('DOMContentLoaded', () => {
   subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
      const templates = Array.from(document.querySelectorAll('.gf-cart-message'), (node) => {
         return String(node.id || '').replace(/^shopify-section-/, '');
      });

      fetch(`${Shopify.routes.root}?sections=${templates.filter(Boolean).join(',')}`)
         .then(r => r.json())
         .then(json => {
            for (const [id, content] of Object.entries(json)) {
               const node = document.querySelector(`#shopify-section-${id}`);
               if (node) {
                  node.innerHTML = content;
               }
            }
         })
   });
})
